import React from 'react'

import ContentPage from './ContentPage.jsx'

import es from '../locales/medicalDisclaimer_es.json'
import en from '../locales/medicalDisclaimer_en.json'

function MedicalDisclaimer() {
    return <ContentPage es={es} en={en} />
}

export default MedicalDisclaimer
